import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      // component: resolve => require(["@/view/HomePage"], resolve),
      component: resolve => require(["@/view/home/index"], resolve),
      meta: {
        title: "首页"
      }
    },
    {
      path: "/solution",
      name: "solution",
      component: resolve => require(["@/view/solution/index"], resolve),
      meta: {
        title: "解决方案"
      }
    },
    //解决方案-内容
    {
      path: "/solution-info",
      name: "solution-info",
      component: resolve => require(["@/view/solution/detail"], resolve),
      meta: {
        title: "解决方案"
      }
    },
    {
      path: "/news",
      name: "news",
      component: resolve => require(["@/view/news/index"], resolve),
      meta: {
        title: "新闻公告"
      }
    },
    {
      path: "/company",
      name: "company",
      component: resolve => require(["@/view/company/index"], resolve),
      meta: {
        title: "关于AIFC"
      }
    },
    {
      path: "/newsdetail",
      name: "newsdetail",
      component: resolve => require(["@/view/news/detail"], resolve),
      meta: {
        title: "新闻详情"
      }
    },
    {
      path: "/jobs",
      name: "jobs",
      component: resolve => require(["@/view/jobs/index"], resolve),
      meta: {
        title: "招贤纳士"
      }
    },

    // old版本
    {
      path: "/smartTown",
      name: "XDWL",
      component: resolve => require(["@/view/Software_smartTown"], resolve),
      meta: {
        title: "星地网链系统"
      }
    },
    {
      path: "/software/bigData",
      name: "ZNWS",
      component: resolve => require(["@/view/Software_bigData"], resolve),
      meta: {
        title: "智能文书系统"
      }
    },
    {
      path: "/service",
      name: "service",
      component: resolve => require(["@/view/Service"], resolve),
      meta: {
        title: "相关服务"
      }
    },
    {
      path: "/newsinformation",
      name: "newsinformation",
      component: resolve => require(["@/view/NewsInformation"], resolve),
      meta: {
        title: "新闻动态"
      }
    },
    // {
    //   path: "/newsdetail",
    //   name: "newsdetail",
    //   component: resolve => require(["@/view/NewsDetail"], resolve),
    //   meta: {
    //     title: "新闻详情"
    //   }
    // },
    {
      path: "/companyintroduction",
      name: "companyintroduction",
      component: resolve => require(["@/view/CompanyIntroduction"], resolve),
      meta: {
        title: "公司介绍"
      }
    },
    {
      path: "/jobchance",
      name: "jobchance",
      component: resolve => require(["@/view/JobChance"], resolve),
      meta: {
        title: "工作机会"
      }
    },
    {
      path: "/contactus",
      name: "contactus",
      component: resolve => require(["@/view/ContactUs"], resolve),
      meta: {
        title: "联系我们"
      }
    },
    {
      path: "/servicedetail",
      name: "servicedetail",
      component: resolve => require(["@/view/ServiceDetail"], resolve),
      meta: {
        title: "智飞服务"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js